export {
  default as LearnerHomeWidgetBlock,
} from "./learner-home-widget-block-container";



// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/learner-home-widget-block/index.js